import React, { useState, useEffect } from 'react';
import { CloseIcon, IdenifyIcon, ArrowRightIcon, CommentInfoIcon, QouteStart, QouteEnd } from 'ui-component/custom-icons/icons';
import Select from 'react-select';
import CommentBadge from '../components/CommentBadge';

// ✅ Clear
const GradingModalMobile = ({ openPopup, details, handleClose, handleProcessGrading }) => {
    const [gradeList, setGradeList] = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);

    useEffect(() => {
        if (!openPopup) return;
        api.getSelectOptionsList('grade').then((res) => {
            if (res?.data) {
                const grades = res?.data?.map((item) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item;
                });
                setGradeList(grades);
            }
        });
        initializeItems();
        // eslint-disable-next-line
    }, [openPopup]);

    const initializeItems = () => {
        const checkedItems = details?.filter((item) => item.isChecked);
        setSelectedItems(checkedItems);
    };

    const handleChangeGrade = (e, itemId) => {
        const updatedItems = selectedItems.map((item) => {
            if (item.id === itemId) {
                return { ...item, oldGradeId: e.id, oldGradeName: e?.label };
            }
            return item;
        });
        setSelectedItems(updatedItems);
    };

    const showCommentSection = (index) => {
        setSelectedItems(prevItems =>
            prevItems.map((item, i) =>
                i === index ? { ...item, showComment: true } : item
            )
        );
    };

    const closeComment = (index) => {
        setSelectedItems(prevItems =>
            prevItems.map((item, i) =>
                i === index ? { ...item, showComment: false, comment: '' } : item
            )
        );
    };

    const updateCommentField = (e, index) => {
        setSelectedItems(prevItems =>
            prevItems.map((item, i) =>
                i === index ? { ...item, comment: e?.target?.value } : item
            )
        );
    };

    const saveComment = (index) => {
        setSelectedItems(prevItems =>
            prevItems.map((item, i) =>
                i === index ? { ...item, showComment: false } : item
            )
        );
    };

    const submitForm = () => {
        handleProcessGrading(selectedItems);
    };

    if (!openPopup) return null;

    return (
        <div
            className="d-flex"
            style={{
                width: '100vw',
                height: '100dvh',
                position: 'fixed',
                left: 0,
                top: 0,
                zIndex: 22,
                background: 'rgba(0,0,0,0.07)',
                justifyContent: 'center',
                alignItems: 'end',
                paddingBottom: '90px',
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)'
            }}
        >
            <div
                className="popup product-popup-mobile d-md-none"
                style={{
                    position: 'relative',
                    transform: 'none',
                    top: 0,
                    left: 0,
                    maxWidth: '90%',
                    background: '#fff',
                    borderRadius: 12,
                    boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
                    width: '100%',
                    minHeight: '50dvh',
                    padding: '24px 16px 0 16px',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                    <div style={{ flex: 1, textAlign: 'center' }}>
                        <IdenifyIcon height={'60px'} width={'60px'} />
                        <div style={{ fontSize: '22px', fontWeight: 600, marginTop: 8 }}>Identify Grading</div>
                        <div style={{ fontSize: 14, color: '#888' }}>Select new grade for selected IMEIs</div>
                    </div>
                </div>

                <div style={{ flex: 1, overflowY: 'auto', paddingBottom: 16 }}>
                    {selectedItems?.length > 0 && selectedItems.map((item, index) => (
                        <div key={item.id} style={{ marginBottom: 18, borderRadius: 8, background: '#f9f9f9', padding: 12 }}>
                            {item?.showComment ? (
                                <div className="comment-section" style={{ marginBottom: 8 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                        <span style={{ fontSize: 14, fontWeight: 500 }}>Comment</span>
                                        <span className="cursor-pointer" onClick={() => closeComment(index)}>
                                            <CloseIcon height={'14px'} width={'14px'} />
                                        </span>
                                    </div>
                                    {item?.hasComment ? (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 4, color: '#444', fontSize: 14, marginBottom: 8 }}>
                                            <QouteStart />
                                            <span>{item?.comment}</span>
                                            <QouteEnd />
                                        </div>
                                    ) : (
                                        <>
                                            <textarea
                                                className="form-control"
                                                rows="2"
                                                value={item?.comment}
                                                onChange={(e) => updateCommentField(e, index)}
                                                style={{ resize: 'none', marginBottom: 8 }}
                                            />
                                            <div style={{ textAlign: 'right' }}>
                                                <button type="button" onClick={() => saveComment(index)} className="btn btn-primary btn-outlined-main btn-sm">
                                                    Save Comment
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ) : (
                                <>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                                        <div style={{ fontWeight: 500, fontSize: 15 }}>{item?.imei}</div>
                                        <div
                                            className="cursor-pointer"
                                            style={{ marginLeft: 8, position: 'relative' }}
                                            onClick={() => showCommentSection(index)}
                                        >
                                            <CommentInfoIcon height='20' width='20' />
                                            {(item?.hasComment || (item?.comment && item?.comment.trim() !== '')) && (
                                                <CommentBadge count="1" />
                                            )}
                                        </div>
                                    </div>
                                    <div style={{ color: '#888', fontSize: 13, marginBottom: 8 }}>
                                        {item?.productName} {item?.colorName ? `(${item?.colorName})` : ''}
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <input
                                            type="text"
                                            value={item?.newGradeName}
                                            disabled
                                            className="form-control"
                                            style={{ background: '#f1f1f1', fontSize: 14, width: '40%' }}
                                        />
                                        <ArrowRightIcon height='24px' width='24px' />
                                        <div style={{ flex: 1 }}>
                                            <Select
                                                options={gradeList}
                                                className="rs-container"
                                                classNamePrefix="rs"
                                                placeholder="Select or type..."
                                                isMulti={false}
                                                onChange={(e) => handleChangeGrade(e, item?.id)}
                                                value={gradeList?.find(option => option.id === item.oldGradeId) || null}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    ))}
                </div>

                {/* Sticky bottom buttons */}
                <div
                    className="btnarea"
                    style={{
                        position: 'sticky',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        background: '#fff',
                        padding: '16px 0 12px 0',
                        zIndex: 30,
                        display: 'flex',
                        gap: 10,
                        justifyContent: 'center',
                        marginTop: 'auto'
                    }}
                >
                    <button
                        className="btn btn-main"
                        onClick={submitForm}
                    >
                        Save
                    </button>
                    <button className="btn new-btn-error" onClick={handleClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GradingModalMobile;
